"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
exports.default = (0, react_1.css) `
    .y-input {
        position: relative;
        display: inline-block;
        width: 100%;
    }

    .y-input__box {
        position: relative;
        box-sizing: border-box;
        cursor: text;
    }

    .y-input__box:before {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding: 0;
        background-clip: padding-box;
        content: "";
    }

    .y-input__control {
        position: relative;
        z-index: 3;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        width: 100%;
        outline: 0;
        border: 0 solid transparent;
        background: none;
        color: #000;
        vertical-align: top;
        font-size: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-appearance: none;
    }

    .y-input__control::-webkit-search-decoration {
        -webkit-appearance: none;
    }

    .y-input__control::-webkit-search-cancel-button {
        display: none;
    }

    .y-input__control::-ms-clear {
        display: none;
    }

    .y-input__control:-webkit-autofill {
        border-top-width: 2px;
        border-bottom-width: 2px;
        background-clip: content-box;
        -webkit-box-shadow: inset 0 0 0 50px #fff;
        -webkit-text-fill-color: #000;
    }

    .y-input__clear {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 5;
        visibility: visible;
        margin: 0;
        padding: 0;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        opacity: 0.3;
        cursor: pointer;
        transition: opacity 0.1s ease-out;
    }

    .y-input__clear:hover {
        opacity: 0.8;
    }

    .y-input_disabled .y-input__clear {
        display: none;
    }

    .y-input_theme_normal,
    .y-input_theme_normal .y-input__control {
        color: #000;
        font-family: var(--main-font);
    }

    .y-input_theme_normal.y-input_disabled .y-input__control {
        color: #aaa;
        -webkit-text-fill-color: #aaa;
    }

    .y-input_theme_normal .y-input__control::-webkit-input-placeholder {
        color: #999;
    }

    .y-input_theme_normal .y-input__control::-moz-placeholder {
        color: #999;
        opacity: 1;
    }

    .y-input_theme_normal .y-input__control:-ms-input-placeholder {
        color: #999;
    }

    .y-input_theme_normal .y-input__hint {
        color: #999;
    }

    .y-input_theme_normal .y-input__box:before {
        border: 1px solid rgba(0, 0, 0, 0.2);
        background-color: #fff;
        background-clip: padding-box;
        transition: 0.1s ease-out;
        transition-property: border-color, border-width;
    }

    .y-input_theme_normal.y-input_textarea .y-input__box:before {
        transition-property: border-color, border-width, top, left, right,
            bottom;
    }

    .y-input_theme_normal.y-input_hovered .y-input__box:before {
        border-color: rgba(0, 0, 0, 0.3);
    }

    .y-input_theme_normal.y-input_focused .y-input__box:before {
        border: 2px solid var(--view-default-fill-color-action);
    }

    .y-input_theme_normal.y-input_disabled .y-input__box:before {
        border-color: transparent;
        background-color: rgba(0, 0, 0, 0.08);
    }

    .y-input_size_xs {
        font-size: 13px;
        line-height: 24px;
    }

    .y-input_size_xs .y-input__control {
        line-height: 24px;
    }

    .y-input_size_xs .y-input__control,
    .y-input_size_xs .y-input__hint {
        height: 24px;
        border-right-width: 7px;
        border-left-width: 7px;
    }

    .y-input_size_xs .y-input__icon {
        width: 24px;
    }

    .y-input_size_xs .y-input__clear {
        width: 24px;
        height: 24px;
        background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCI+PHBvbHlnb24gcG9pbnRzPSIxMCwwLjcgOS4zLDAgNSw0LjMgMC43LDAgMCwwLjcgNC4zLDUgMCw5LjMgMC43LDEwIDUsNS43IDkuMywxMCAxMCw5LjMgNS43LDUiLz48L3N2Zz4K");
    }

    .y-input_size_xs .y-input__icon_side_right ~ .y-input__clear {
        right: 12px;
    }

    .y-input_size_xs .y-input__clear ~ .y-input__control {
        border-right-width: 19px;
    }

    .y-input_size_xs
        .y-input__icon_side_right
        ~ .y-input__clear
        ~ .y-input__control {
        border-right-width: 31px;
    }

    .y-input_size_xs .y-input__hint.y-input__hint_rpad,
    .y-input_size_xs .y-input__icon_side_right ~ .y-input__control {
        border-right-width: 24px;
    }

    .y-input_size_xs .y-input__hint.y-input__hint_lpad,
    .y-input_size_xs .y-input__icon_side_left ~ .y-input__control {
        border-left-width: 24px;
    }

    .y-input_size_xs.y-input_textarea .y-input__control {
        padding: 3px 5px;
    }

    .y-input_size_s {
        font-size: 13px;
    }

    .y-input_size_s,
    .y-input_size_s .y-input__control {
        line-height: 28px;
    }

    .y-input_size_s .y-input__control,
    .y-input_size_s .y-input__hint {
        height: 28px;
        border-right-width: 8px;
        border-left-width: 8px;
    }

    .y-input_size_s .y-input__icon {
        width: 28px;
    }

    .y-input_size_s .y-input__clear {
        width: 28px;
        height: 28px;
        background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCI+PHBvbHlnb24gcG9pbnRzPSIxMCwwLjcgOS4zLDAgNSw0LjMgMC43LDAgMCwwLjcgNC4zLDUgMCw5LjMgMC43LDEwIDUsNS43IDkuMywxMCAxMCw5LjMgNS43LDUiLz48L3N2Zz4K");
    }

    .y-input_size_s .y-input__icon_side_right ~ .y-input__clear {
        right: 14px;
    }

    .y-input_size_s .y-input__clear ~ .y-input__control {
        border-right-width: 22px;
    }

    .y-input_size_s
        .y-input__icon_side_right
        ~ .y-input__clear
        ~ .y-input__control {
        border-right-width: 36px;
    }

    .y-input_size_s .y-input__hint.y-input__hint_rpad,
    .y-input_size_s .y-input__icon_side_right ~ .y-input__control {
        border-right-width: 28px;
    }

    .y-input_size_s .y-input__hint.y-input__hint_lpad,
    .y-input_size_s .y-input__icon_side_left ~ .y-input__control {
        border-left-width: 28px;
    }

    .y-input_size_s.y-input_textarea .y-input__control {
        padding: 4px 6px;
    }

    .y-input_size_s.y-input_textarea .y-input__clear ~ .y-input__control {
        padding-inline-end: 22px;
    }

    .y-input_size_m {
        font-size: 15px;
    }

    .y-input_size_m,
    .y-input_size_m .y-input__control {
        line-height: 32px;
    }

    .y-input_size_m .y-input__control,
    .y-input_size_m .y-input__hint {
        height: 32px;
        border-right-width: 10px;
        border-left-width: 10px;
    }

    .y-input_size_m .y-input__icon {
        width: 32px;
    }

    .y-input_size_m .y-input__clear {
        width: 32px;
        height: 32px;
        background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCI+PHBvbHlnb24gcG9pbnRzPSIxNCwwLjcgMTMuMywwIDcsNi4zIDAuNywwIDAsMC43IDYuMyw3IDAsMTMuMyAwLjcsMTQgNyw3LjcgMTMuMywxNCAxNCwxMy4zIDcuNyw3Ii8+PC9zdmc+Cg==");
    }

    .y-input_size_m .y-input__icon_side_right ~ .y-input__clear {
        right: 16px;
    }

    .y-input_size_m .y-input__clear ~ .y-input__control {
        border-right-width: 26px;
    }

    .y-input_size_m
        .y-input__icon_side_right
        ~ .y-input__clear
        ~ .y-input__control {
        border-right-width: 42px;
    }

    .y-input_size_m .y-input__hint.y-input__hint_rpad,
    .y-input_size_m .y-input__icon_side_right ~ .y-input__control {
        border-right-width: 32px;
    }

    .y-input_size_m .y-input__hint.y-input__hint_lpad,
    .y-input_size_m .y-input__icon_side_left ~ .y-input__control {
        border-left-width: 32px;
    }

    .y-input_size_m.y-input_textarea .y-input__control {
        padding: 6px 8px;
    }

    .y-input_size_m.y-input_textarea .y-input__clear ~ .y-input__control {
        padding-inline-end: 30px;
    }

    .y-input_textarea {
        vertical-align: top;
    }

    .y-input_textarea .y-input__control {
        display: block;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        min-height: 2em;
        height: auto;
        border-width: 0 !important;
        vertical-align: baseline;
        line-height: normal;
        resize: vertical;
    }

    .y-input_textarea .y-input__box {
        padding: 1px 1px 1px 0;
    }

    .y-input_textarea.y-input_focused .y-input__box:before {
        top: -1px;
        right: -1px;
        bottom: -1px;
        left: -1px;
    }

    .y-input_textarea.y-input_disabled .y-input__control {
        resize: none;
    }

    .y-input_pin_brick-clear .y-input__box:before {
        border-right-width: 0;
    }

    .y-input_pin_brick-round .y-input__box:before {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
    }

    .y-input_pin_clear-brick .y-input__box:before {
        border-left-width: 0;
    }

    .y-input_pin_clear-clear .y-input__box:before {
        border-right-width: 0;
        border-left-width: 0;
    }

    .y-input_pin_clear-round .y-input__box:before {
        border-left-width: 0;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
    }

    .y-input_pin_round-brick .y-input__box:before {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
    }

    .y-input_pin_round-clear .y-input__box:before {
        border-right-width: 0;
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
    }

    .y-input_pin_round-round .y-input__box:before {
        border-radius: 3px;
    }

    .y-radio {
        display: inline-block;
        cursor: pointer;
    }

    .y-radio__control {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1;
        opacity: 0;
        cursor: pointer;
    }

    .y-radio__box {
        position: relative;
        display: inline-block;
    }

    .utilityfocus
        .y-radio_theme_normal
        .y-radio__control:focus
        + .y-radio__view {
        border-width: 2px;
        border-color: var(--view-default-fill-color-action);
    }

    .y-radio_theme_normal .y-radio__view {
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 100%;
        background-color: #fff;
        background-clip: padding-box;
        transition: 0.1s ease-out;
        transition-property: border-color, border-width, background-color;
    }

    .y-radio_theme_normal :checked ~ .y-radio__view {
        border-color: rgba(153, 122, 0, 0.5);
        background-color: #ffeba0;
    }

    .y-radio_theme_normal :checked ~ .y-radio__point {
        position: absolute;
        border-radius: 100px;
        background-color: #000;
        content: "";
    }

    .y-radio_theme_normal:not(.y-radio_disabled):hover .y-radio__view {
        border-color: rgba(0, 0, 0, 0.3);
    }

    .y-radio_theme_normal.y-radio_checked:not(.y-radio_disabled):hover
        .y-radio__view {
        border-color: rgba(129, 103, 0, 0.6);
    }

    .y-radio_size_m {
        font-size: 15px;
        line-height: 32px;
    }

    .y-radio_size_m .y-radio__box {
        top: 3px;
        width: 17px;
        height: 17px;
    }

    .y-radio_size_m.y-radio_checked .y-radio__point {
        top: 5px;
        left: 5px;
        width: 7px;
        height: 7px;
    }

    .y-radio_size_m .y-radio__text {
        padding-inline-start: 7px;
    }

    .y-radio_size_s {
        font-size: 13px;
        line-height: 28px;
    }

    .y-radio_size_s .y-radio__box {
        top: 2px;
        width: 14px;
        height: 14px;
    }

    .y-radio_size_s.y-radio_checked .y-radio__point {
        top: 4px;
        left: 4px;
        width: 6px;
        height: 6px;
    }

    .y-radio_size_s .y-radio__text {
        padding-inline-start: 5px;
    }

    .y-radio_disabled,
    .y-radio_disabled .y-radio__control {
        cursor: default;
    }

    .y-radio_disabled .y-radio__text {
        opacity: 0.5;
    }

    .y-radio_disabled .y-radio__view {
        border-color: rgba(0, 0, 0, 0.08);
        background-color: rgba(0, 0, 0, 0.08);
    }

    .y-radio_disabled .y-radio__point {
        opacity: 0.4;
    }

    .y-radio_disabled.y-radio_checked .y-radio__view {
        border-color: rgba(0, 0, 0, 0.15);
        background-color: rgba(0, 0, 0, 0.15);
    }

    .y-radio__view {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    .y-button {
        overflow: visible;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        text-decoration: none;
        font-family: var(--main-font);
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    .utilityfocus .y-button_theme_normal.y-button_focused:before {
        border-width: 2px;
        border-color: var(--view-default-fill-color-action);
    }

    .utilityfocus .y-button_theme_action.y-button_focused:before {
        animation: a 1s infinite linear;
    }

    .utilityfocus
        .y-button_theme_promo.y-button_focused.y-button_focused.y-button_size_l:before,
    .utilityfocus
        .y-button_theme_promo.y-button_focused.y-button_focused.y-button_size_xl:before {
        box-shadow: inset 0 -4px #d0ad24, 0 0 10px #deb616;
    }

    .utilityfocus
        .y-button_theme_promo.y-button_focused.y-button_focused.y-button_size_m:before,
    .utilityfocus
        .y-button_theme_promo.y-button_focused.y-button_focused.y-button_size_s:before {
        box-shadow: inset 0 -3px #d0ad24, 0 0 10px #deb616;
    }

    .utilityfocus
        .y-button_theme_promo.y-button_focused.y-button_focused.y-button_pressed:not(
            .y-button_view_flying
        ):before {
        box-shadow: inset 0 -1px #d0ad24, 0 0 10px #deb616;
    }

    .utilityfocus .y-button_theme_pseudo.y-button_focused:before {
        border-width: 2px;
        border-color: var(--view-default-fill-color-action);
    }

    .utilityfocus .y-button_theme_minor.y-button_focused:before {
        box-shadow: 0 0 10px #deb616;
    }

    @keyframes a {
        0%,
        to {
            background-color: #fc0;
        }

        40%,
        60% {
            background-color: #ffe066;
        }
    }
`;
